import { Box, Stack, Typography, useTheme } from '@mui/joy';

const RadialLegend = ({
	showInd,
	small,
	index,
	hasEdgeCases = true,
	count,
	print = false
}: {
	showInd: boolean;
	small?: boolean;
	index?: number;
	hasEdgeCases?: boolean;
	count: number;
	print?: boolean;
}) => {
	const theme = useTheme();
	const legendItems = [
		{
			color: theme.colorSchemes.light.palette.categoryPartyDemocratMen.solidBg,
			label: 'Dem M'
		},
		{
			color:
				theme.colorSchemes.light.palette.categoryPartyDemocratWomen.solidBg,
			label: 'Dem W'
		},
		{
			color:
				theme.colorSchemes.light.palette.categoryPartyIndependentWomen.solidBg,
			label: 'Ind W'
		},
		{
			color:
				theme.colorSchemes.light.palette.categoryPartyRepublicanWomen.solidBg,
			label: 'Rep W'
		},
		{
			color:
				theme.colorSchemes.light.palette.categoryPartyRepublicanMen.solidBg,
			label: 'Rep M'
		}
	];

	const isVisible =
		hasEdgeCases && (index as number) % count !== 0 ? 'hidden' : 'visible';

	return (
		<Stack
			direction='row'
			sx={{
				justifyContent: 'center',
				width: '100%',
				marginTop: small ? '-30px' : '30px',
				mb: '2rem'
			}}
		>
			{legendItems.map(({ color, label }, i) =>
				!showInd && i === 2 ? null : (
					<Stack
						key={label}
						direction='row'
						alignItems='center'
						sx={{ flexWrap: 'nowrap', visibility: isVisible }}
					>
						<Box
							sx={{
								backgroundColor: color,
								borderRadius: '50%',
								width: '14px',
								height: '14px',
								mt: print ? '1rem' : 0,
								mr: '.25rem',
								minWidth: '14px'
							}}
						></Box>
						<Typography
							level='chartSubtitle'
							sx={{ fontSize: '15px', mr: '.75rem', whiteSpace: 'nowrap' }}
						>
							{label}
						</Typography>
					</Stack>
				)
			)}
		</Stack>
	);
};

export default RadialLegend;
